module.exports = __webpack_public_path__ + "media/images/common/services/say/logo-372654d2796087af244b48307d61aa36.png";